import Certificate from './Certificate'

export default Certificate
// eslint-disable-next-line import/export
export * from './Certificate'
